const SVG = () => (
    <svg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg">
        <defs>
            <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stop-color="#e0e0e0" />
                <stop offset="100%" stop-color="#888888" />
            </linearGradient>
        </defs>
        <circle
            cx="30"
            cy="30"
            r="25"
            fill="none"
            stroke="url(#grad1)"
            stroke-width="8"
            stroke-dasharray="120 40"
            stroke-linecap="round"
            transform="rotate(-90 30 30)"
        >
            <animateTransform
                attributeName="transform"
                type="rotate"
                from="0 30 30"
                to="360 30 30"
                dur="1s"
                repeatCount="indefinite"
            />
        </circle>
    </svg>
)

export default SVG
